import Axios from "axios";
import {
    SET_HRM_MARITAL_STATUS_LIST,
    UNSET_HRM_MARITAL_STATUS_LIST,
  } from "@/store/mutation-types";
import {getHrmMaritalStatusList} from "@/store/api";
// initial state
const state = {
  getHrmMaritalStatusList: [],
};

const getters = {
  getHrmMaritalStatusList(state) {
    return state.getHrmMaritalStatusList;
  },
};

const mutations = {
  [SET_HRM_MARITAL_STATUS_LIST](state, data) {
    state.getHrmMaritalStatusList = data;
  },
  [UNSET_HRM_MARITAL_STATUS_LIST](state) {
    state.getHrmMaritalStatusList = [];
  },

};

const actions = {

  getHrmMaritalStatusList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmMaritalStatusList, data)
        .then(function (response) {
          commit('SET_HRM_MARITAL_STATUS_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_MARITAL_STATUS_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
